import { CTAButton as UiCTAButton, styledForMobile } from "@l2r-front/l2r-ui"

export const CTAButton = styledForMobile(UiCTAButton)(({ isMobile }) => ({
    flex: isMobile && "1 1 auto",
}))